import { IS_IO } from 'lib/site';

// examing.io wears its own brand: index.css swaps the primary palette under
// html[data-site='io'], and the tab icon switches to the blueberry mark.
if (IS_IO && typeof document !== 'undefined') {
  document.documentElement.dataset.site = 'io';
  document.querySelector<HTMLLinkElement>('link[rel="icon"]')?.setAttribute('href', '/favicon-io.svg');
}
